import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/pages/Login/LoginPage.vue'
import UnidadAcademicaPage from '@/pages/UnidadAcademica/UnidadAcademicaPage.vue'
import RolPage from '@/pages/Rol/RolPage.vue'
import PersonaPage from '@/pages/Persona/PersonaPage.vue'
import PrincipalPage from '@/pages/Principal/PrincipalPage.vue'
import ProfilePage from '@/pages/Profile/ProfilePage.vue'

import Presentacion18Page from '@/pages/Presentacion18/Presentacion18Page.vue'
import CapituloUno18Page from '@/pages/CapituloUno18/CapituloUno18Page.vue'
import CapituloDos18Page from '@/pages/CapituloDos18/CapituloDos18Page.vue'
import CapituloTres18Page from '@/pages/CapituloTres18/CapituloTres18Page.vue'
import CapituloCuatro18Page from '@/pages/CapituloCuatro18/CapituloCuatro18Page.vue'
import CapituloCinco18Page from '@/pages/CapituloCinco18/CapituloCinco18Page.vue'

import CapituloSeis18Page from '@/pages/CapituloSeis18/CapituloSeis18Page.vue'
import Anexos18Page from '@/pages/Anexos18/Anexos18Page.vue'

import CapituloUnoPage from '@/pages/CapituloUno/CapituloUnoPage.vue'
import CapituloDosPage from '@/pages/CapituloDos/CapituloDosPage.vue'
import CapituloTresPage from '@/pages/CapituloTres/CapituloTresPage.vue'
import CapituloCuatroPage from '@/pages/CapituloCuatro/CapituloCuatroPage.vue'
import CapituloCincoPage from '@/pages/CapituloCinco/CapituloCincoPage.vue'
import CapituloSeisPage from '@/pages/CapituloSeis/CapituloSeisPage.vue'
import CapituloSietePage from '@/pages/CapituloSiete/CapituloSietePage.vue'
import CapituloOchoPage from '@/pages/CapituloOcho/CapituloOchoPage.vue'
import CapituloNuevePage from '@/pages/CapituloNueve/CapituloNuevePage.vue'
import CapituloDiezPage from '@/pages/CapituloDiez/CapituloDiezPage.vue'
import CapituloOncePage from '@/pages/CapituloOnce/CapituloOncePage.vue'
import CapituloDocePage from '@/pages/CapituloDoce/CapituloDocePage.vue'
import CapituloTrecePage from '@/pages/CapituloTrece/CapituloTrecePage.vue'
import MateriaPage from '@/pages/Materia/MateriaPage.vue'
import ValidacionPage from '@/pages/Validacion/ValidacionPage.vue'
import AnexosPage from '@/pages/Anexos/AnexosPage.vue'
import PresentacionPage from '@/pages/Presentacion/PresentacionPage.vue'
import ImprimirPage from '@/pages/Imprimir/ImprimirPage.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'PrincipalPage',
      component: PrincipalPage
    },
    {
      path: '/UnidadAcademica',
      name: 'Unidad Academica',
      component: UnidadAcademicaPage
    },
    {
      path: '/Rol',
      name: 'Rol',
      component: RolPage
    },
    {
      path: '/Persona',
      name: 'Persona',
      component: PersonaPage
    },
    {
      path: '/Profile',
      name: 'Perfil',
      component: ProfilePage
    },
    {
      path: '/Login',
      name: 'Login',
      component: LoginPage
    },

    //MALLA 2018-2022
    {
      path: '/Presentacion18',
      name: 'Presentacion18',
      component: Presentacion18Page
    },
    {
      path: '/CapituloUno18',
      name: 'CapituloUno18',
      component: CapituloUno18Page
    },
    {
      path: '/CapituloDos18',
      name: 'CapituloDos18',
      component: CapituloDos18Page
    },
    {
      path: '/CapituloTres18',
      name: 'CapituloTres18',
      component: CapituloTres18Page
    },

    {
      path: '/CapituloCuatro18',
      name: 'CapituloCuatro18',
      component: CapituloCuatro18Page
    },

    {
      path: '/CapituloCinco18',
      name: 'CapituloCinco18',
      component: CapituloCinco18Page
    },

    {
      path: '/CapituloSeis18',
      name: 'CapituloSeis18',
      component: CapituloSeis18Page
    },
    {
      path: '/Anexos18',
      name: 'Anexos18',
      component: Anexos18Page
    },

    //MALLA 2024-2028
    {
      path: '/CapituloUno',
      name: 'CapituloUno',
      component: CapituloUnoPage
    },
    {
      path: '/CapituloDos',
      name: 'CapituloDos',
      component: CapituloDosPage
    },
    {
      path: '/CapituloTres',
      name: 'CapituloTres',
      component: CapituloTresPage
    },
    {
      path: '/CapituloCuatro',
      name: 'CapituloCuatro',
      component: CapituloCuatroPage
    },
    {
      path: '/CapituloCinco',
      name: 'CapituloCinco',
      component: CapituloCincoPage
    },
    {
      path: '/CapituloSeis',
      name: 'CapituloSeis',
      component: CapituloSeisPage
    },
    {
      path: '/CapituloSiete',
      name: 'CapituloSiete',
      component: CapituloSietePage
    },
    {
      path: '/CapituloOcho',
      name: 'CapituloOcho',
      component: CapituloOchoPage
    },
    {
      path: '/CapituloNueve',
      name: 'CapituloNueve',
      component: CapituloNuevePage
    },
    {
      path: '/CapituloDiez',
      name: 'CapituloDiez',
      component: CapituloDiezPage
    },
    {
      path: '/CapituloOnce',
      name: 'CapituloOnce',
      component: CapituloOncePage
    },
    {
      path: '/CapituloDoce',
      name: 'CapituloDoce',
      component: CapituloDocePage
    },
    {
      path: '/CapituloTrece',
      name: 'CapituloTrece',
      component: CapituloTrecePage
    },
    {
      path: '/Materia',
      name: 'Materia',
      component: MateriaPage
    },
    {
      path: '/Validacion',
      name: 'Validacion',
      component: ValidacionPage
    },
    {
      path: '/Anexos',
      name: 'Anexos',
      component: AnexosPage
    },
    {
      path: '/Presentacion',
      name: 'Presentacion',
      component: PresentacionPage
    },
    {
      path: '/Imprimir',
      name: 'Imprimir',
      component: ImprimirPage
    }
  ]
})